const handleDeleteDocumentModalDocEmployee = {
  confirm: '¿Realmente desea eliminar esta entrada?',
  title: 'ELIMINAR DOCUMENTO'
};

export default handleDeleteDocumentModalDocEmployee;
